// @owners { team: patients-team }
export const INCREMENT_TRANSFER_UPSELL_VIEW_COUNT = 'INCREMENT_TRANSFER_UPSELL_VIEW_COUNT';
export function incrementTransferUpsellViewCount() {
  return { type: INCREMENT_TRANSFER_UPSELL_VIEW_COUNT } as const;
}

export type Actions = ReturnType<typeof incrementTransferUpsellViewCount>;
